(function () {
	angular
		.module('trackeye')
		.factory('DispatchLog', _DispatchLogFactory);

	_DispatchLogFactory.$inject = ['C4ApiService', '$location', 'ResponseXHR'];

	function _DispatchLogFactory(api, $location, ResponseXHR) {
		var exports = {},
			account = "N/A";

		exports.setAccount = function (name) {
			account = name;
		};

		/**
		 * @param {string} short_message
		 * @param {string} message
		 * @param {object} [data]
		 * @param {ResponseXHR} [xhr]
		 */
		exports.DEBUG = function (short_message, message, data, xhr) {
			console.debug(dispatch('debug', short_message, message, data, xhr));
		};

		/**
		 * @param {string} short_message
		 * @param {string} message
		 * @param {object} [data]
		 * @param {ResponseXHR} [xhr]
		 */
		exports.INFO = function (short_message, message, data, xhr) {
			console.info(dispatch('info', short_message, message, data, xhr));
		};

		/**
		 * @param {string} short_message
		 * @param {string} message
		 * @param {object} [data]
		 * @param {ResponseXHR} [xhr]
		 */
		exports.ERR = function (short_message, message, data, xhr) {
			console.warn(dispatch('err', short_message, message, data, xhr));
		};

		exports.byHandle = function (handle) {
			_log(dispatch(
				handle.getLevel(),
				handle.getMessageId(),
				handle.getMessage(),
				handle.getData(),
				handle.getXhr()
			));
		};

		function dispatch(type, message_id, message, data, xhr) {
			var log = {
				account: account,
				url: $location.$$path,
				message_id: message_id,
				message: message,
				data: data
			};

			if (xhr instanceof ResponseXHR) {
				angular.extend(log, {status: xhr.getStatus(), responseData: xhr.getResponseData()});
			}
			//api.dispatchLog(type, log);
			return log;
		}

		return exports;
	}
}());